// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"b1ee6a31","821":"b4b3ee7a"}[chunkId] + ".chunk.js";
};